import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";

export default function useChangeProfile() {
  const [fetchedData, setFetchedData] = useState([]);
  const [error, setError] = useState(null);
  const { config, role, id, IDPacient } = useSelector((state) => state.user);
  const token = localStorage.getItem("token");
  const fetchResultsData = async ({ repeatPassword, currentPassword }) => {
    setError(null);
    try {
      const requestBody = {
        [role === "patient"
          ? "IDPacient"
          : role === "affiliate"
          ? "IDAffiliate"
          : "IDDoctorGlab"]: role === "doctor" ? id : IDPacient,

        OldPassword: currentPassword,
        NewPassword: repeatPassword,
      };

      const response = await axios.post(
        `${config.apiBaseUrl}/GProfilService/ChangeProfil${
          role.charAt(0).toUpperCase() + role.slice(1)
        }`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFetchedData(response.data);

      return response.data;
    } catch (error) {
      console.error("Error fetching  results:", error);
      setError(error.response?.data?.message || "An unknown error occurred.");
    }
  };

  return { fetchResultsData, IDPacient, fetchedData, error };
}
